import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
/**
 * Import constant.
 */
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from '../../../constants/app.constants';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { PostingService } from '../posting.service';
@Component({
  selector: 'app-post-draft',
  templateUrl: './post-draft.component.html',
  styleUrls: ['./post-draft.component.scss']
})
export class PostDraftComponent implements OnInit, OnDestroy {

  @Output() nextPostScreen=new EventEmitter();
  @Input() callingFrom: string;

  /**
   * start time
   */
  private startTime: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config:any;
  constructor(public dss : DataStorageService,public multilang:MultiLangService, public mls: NewLanguageService, private analyticSdk: Analytics, private postService: PostingService) { }

  ngOnInit(): void {
    this.startTime = new Date().getTime();
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.POST_DRAFT_LIST,
      source: this.callingFrom,
      start_time: this.startTime
    };
    this.analyticSdk.analyticService.ENTRY(entryData);
    this.postService.postingScreen = SCREEN_NAME.POST_DRAFT_LIST;
    if (localStorage.getItem('postDraftData') != null) {
      this.dss.postDraftData = JSON.parse(localStorage.getItem('postDraftData'));
    }
  }

  ngOnDestroy(): void {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.POSTING,
      entity_code: this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0',
      current_screen_name: SCREEN_NAME.POST_DRAFT_LIST,
      start_time: this.startTime,
      end_time: new Date().getTime()
    };
    this.analyticSdk.analyticService.EXIT(exitData);
  }

  deleteFromDraft(idx): void
  {
    this.dss.postDraftData.splice(idx,1);
    localStorage.setItem('postDraftData',JSON.stringify(this.dss.postDraftData));
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_DRAFT_LIST, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.POST_DRAFT_DELETE, null);
    this.dss.nextButtonEnabled = false;
  }

  editDraftData(idx): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.POSTING, this.dss.posting_data.feed_edit_mode.is_edit == 1 ? this.dss.posting_data.feed_edit_mode.feed_id : '0', SCREEN_NAME.POST_DRAFT_LIST, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.POST_DRAFT_EDIT, null);
    this.dss.calling_from_community = NUMBERS.ZERO;
    this.dss.resetRepostData();
    this.dss.edit_draft_index = idx.toString();
    this.dss.draft_index = idx;
    this.dss.posting_data = this.dss.postDraftData[idx];
    this.dss.temp_post_media = this.dss.posting_data.screen1.media;
    this.nextPostScreen.emit(0);
    this.dss.nextButtonEnabled = true;
  }
  /**
   * On clicking update the variable
   */
  isDraftPost(): void {
    this.dss.isDraftPost = NUMBERS.ZERO;
  }
}
